import { batch, useDispatch, useSelector } from "react-redux";
import { useRequest } from "redux-query-react";
import { PmiPricesFromJSON, PriceFromJSON, getPmiPricesById, useImportCustomPmis } from "api/admin/src";
import { is4xxStatusCode } from "common/number-helper";
import { MessagesDialogFunctionName } from "components/frame/helper";
import { language } from "language/default";
import { setValidationMessage } from "store/administration/cashflow-forecasting/model-editing";
import { setMessagesDialog } from "store/messages-dialog";
export const useGetPmiPrices = (id) => {
    const requestParams = id
        ? getPmiPricesById({ id }, {
            transform: (body) => {
                const objResponse = body.map(PriceFromJSON);
                return {
                    PmiPrices: { [id]: objResponse }
                };
            },
            update: {
                PmiPrices: (prevValue, transformedValue) => ({ ...prevValue, ...transformedValue })
            }
        })
        : undefined;
    const [queryState, refresh] = useRequest(requestParams);
    const pmiPrices = useSelector((state) => (id ? state.entities.PmiPrices?.[id] : []));
    return [pmiPrices, queryState, refresh];
};
export const useCustomImportCustomPmis = () => {
    const dispatch = useDispatch();
    const [queryState, mutation] = useImportCustomPmis({
        transform: (body) => {
            const objResponse = body.map(PmiPricesFromJSON);
            return {
                PmiPrices: objResponse.reduce((map, obj) => {
                    map[obj.id ?? ""] = obj.prices ?? [];
                    return map;
                }, {})
            };
        },
        update: {
            PmiPrices: (prevValue, transformedValue) => ({ ...prevValue, ...transformedValue })
        }
    });
    const mut = ((prices, queryParam) => mutation(prices, queryParam)?.then((value) => {
        if (is4xxStatusCode(value?.status)) {
            const responseBodyErrors = value.body;
            const errorMessages = Object.values(responseBodyErrors.errors || {}).flat();
            batch(() => {
                dispatch(setValidationMessage({ validationMessage: errorMessages }));
                if (errorMessages.length > 0) {
                    dispatch(setMessagesDialog({
                        functionName: MessagesDialogFunctionName.Default,
                        messages: errorMessages.map((m) => Object({ message: m })),
                        title: language.en.administration.marketDataAdministration.indices.importValidationErrors.dialogTitle,
                        type: "alert"
                    }));
                }
            });
        }
    }));
    return [queryState, mut];
};
